import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { QuestionnairesDetailContainerState } from './questionnairesdetail';

const initialState: QuestionnairesDetailContainerState = {
  default: 'default',
  questionsList: [],
};

export const questionnairesDetailSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setDefault: (state, action: PayloadAction<any>) => {
      state.default = action.payload;
    },
    toggleCheck: (state, action: PayloadAction<string>) => {
      const item = state.questionsList.find((t: any) => t.id === action.payload);
      if (item) {
        item.checked = !item.checked;
      }
    },
    toggleCheckAll: (state, action: PayloadAction<boolean>) => {
      state.questionsList.forEach((t: any) => {
        t.checked = action.payload;
      });
    },
  },
});

export const {
  setDefault,
  toggleCheck,
  toggleCheckAll,
} = questionnairesDetailSlice.actions;

export default questionnairesDetailSlice.reducer;
